import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";

export default function Clients() {
  return (
    <section className="tekrevol__clients p-100 overflow-x-hidden">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <h2>Our Trusted Clients</h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="slider-wrap">
              <Swiper
                // modules={[Navigation, Pagination]}
                spaceBetween={15}
                slidesPerView={6}
                spaceBetween={50}
                // pagination={{ clickable: true }}
                // navigation
                // navigation={{
                //     prevEl: prevRef?.current,
                //     nextEl: nextRef?.current
                //     }}

                onSwiper={(swiper) => console.log(swiper)}
                onSlideChange={() => console.log("slide change")}
                className="client_slider"
                breakpoints={{
                  320: {
                    slidesPerView: 2,
                  },
                  575: {
                    slidesPerView: 2,
                  },
                  666: {
                    slidesPerView: 2,
                  },
                  768: {
                    slidesPerView: 4,
                  },
                  1199: {
                    slidesPerView: 4,
                  },
                  1200: {
                    slidesPerView: 5,
                    spaceBetween: 50,
                  },
                  1400: {
                    slidesPerView: 5,
                    spaceBetween: 80,
                  },
                }}
              >
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../../images/home-update/client-logos/Mobius.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={266}
                      height={266}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../../images/home-update/client-logos/Kinder_Morgan.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={266}
                      height={266}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../../images/home-update/client-logos/Waste_connections.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={266}
                      height={266}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../../images/home-update/client-logos/uni_of_toronto.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={266}
                      height={266}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../../images/home-update/client-logos/TeeMates.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={266}
                      height={266}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../../images/home-update/client-logos/Saudi_Bell.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={266}
                      height={266}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../../images/home-update/client-logos/Kalaam_logo.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={266}
                      height={266}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../../images/home-update/client-logos/Al_Ghurair.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={266}
                      height={266}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../../images/home-update/client-logos/Al_Husseini.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={266}
                      height={266}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../../images/home-update/client-logos/Truth_GPT.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={266}
                      height={266}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../../images/home-update/client-logos/Pure_Plank.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={266}
                      height={266}
                    />
                  </div>
                </SwiperSlide>

                {/* <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../images/partner/partner-7.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={262}
                      height={262}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../images/partner/partner-16.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={262}
                      height={262}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../images/partner/partner-11.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={262}
                      height={262}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../images/partner/partner-12.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={262}
                      height={262}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../images/partner/partner-15.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={262}
                      height={262}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../images/partner/partner-15.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={262}
                      height={262}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo_box">
                    <StaticImage
                      src="../../images/partner/partner-3.webp"
                      alt="tekrevol_Partner"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={262}
                      height={262}
                    />
                  </div>
                </SwiperSlide> */}
              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
